import { Button } from 'flowbite-react';
import React from 'react';
import { Link } from 'react-router-dom';
// import SubNav from '../components/subNav';
import { baseUrl } from '../config';
import SEO from '../components/SEO';



const collaborations = [
  {
    agencyName: 'Creative Media Agency',
    contactPerson: 'John Doe',
    contactInfo: {
      email: 'johndoe@creative.com',
      phone: '(123) 456-7890',
    },
    description:'Promote the movie on social media',
    location: 'New York, NY',
  },
  {
    agencyName: 'Branding Pros',
    contactPerson: 'Jane Smith',
    contactInfo: {
      email: 'janesmith@brandingpros.com',
      phone: '(987) 654-3210',
    },
    description:'Promote the movie posters through hoardings',
    location: 'Los Angeles, CA',
  },
  // Add more agencies as needed
];

const CollaborationsTable = () => {
  return (
    <>
      <SEO
        title="Collaborations"
        description="Manage and track film project collaborations with your team on ProducerBuddy."
        url="https://producerbuddy.pilomation.com/collaborations"
        robots="noindex, nofollow"
      />
{/* <SubNav/> */}
    <div className=" bg-gray-100 ">
      <div className='flex gap-3'>
        {/* Sidebar */}
        {/* <div className="w-64 bg-gray-800 text-white p-5 space-y-6 h-screen">
        <h1 className="text-2xl font-bold"><Link to='/production-house'>Production Dashboard</Link></h1>
        <nav>
          <ul className="space-y-4 mt-4">
            <li className="hover:text-yellow-400"><Link to='/jobpostings'>Job Postings</Link></li>
            <li className="hover:text-yellow-400">Pre-Production Tools</li>
            <li className="hover:text-yellow-400">Production Status</li>
            <li className="hover:text-yellow-400">Post-Production Tools</li>
            <li className="hover:text-yellow-400"><Link to='/collaborations'>Collaborations</Link></li>
            <li className="hover:text-yellow-400"><Link to='/team'>Team</Link></li>
          </ul>
        </nav>
      </div> */}
      <div className="overflow-x-auto">
      <h1 className="text-3xl mt-4 font-bold mb-8 text-center"style={{fontSize:'24px'}}>Collaborations</h1>
        <table className="min-w-full bg-white shadow-md rounded-lg">
          <thead>
            <tr>
              <th className="py-3 px-6 bg-gray-200 font-semibold text-gray-600 uppercase tracking-wider text-left">
                Agency Name
              </th>
              <th className="py-3 px-6 bg-gray-200 font-semibold text-gray-600 uppercase tracking-wider text-left">
                Contact Person
              </th>
              <th className="py-3 px-6 bg-gray-200 font-semibold text-gray-600 uppercase tracking-wider text-left">
                Contact Info
              </th>
              <th className="py-3 px-6 bg-gray-200 font-semibold text-gray-600 uppercase tracking-wider text-left">
                Task description
              </th>
              <th className="py-3 px-6 bg-gray-200 font-semibold text-gray-600 uppercase tracking-wider text-left">
                Location
              </th>
              <th className="py-3 px-6 bg-gray-200 font-semibold text-gray-600 uppercase tracking-wider text-center">
                Connect
              </th>
            </tr>
          </thead>
          <tbody>
            {collaborations.map((agency, index) => (
              <tr key={index} className="border-b">
                <td className="py-4 px-6 text-gray-700 font-semibold">{agency.agencyName}</td>
                <td className="py-4 px-6 text-gray-700">{agency.contactPerson}</td>
                <td className="py-4 px-6 text-gray-700">
                  <div>
                    <a
                      href={`mailto:${agency.contactInfo.email}`}
                      className="text-blue-500 hover:underline"
                    >
                      {agency.contactInfo.email}
                    </a>
                    <br />
                    <a
                      href={`tel:${agency.contactInfo.phone}`}
                      className="text-blue-500 hover:underline"
                    >
                      {agency.contactInfo.phone}
                    </a>
                  </div>
                </td>
                <td className="py-4 px-6 text-gray-700">{agency.description}</td>
                <td className="py-4 px-6 text-gray-700">{agency.location}</td>
                <td className="py-4 px-6 text-center">
                  <Button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-800">
                    Connect
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </div>
      
    </div>
    </>
    
  );
};

export default CollaborationsTable;

